module.exports = __webpack_public_path__ + "img/car-side-solid.f19b79c3.svg";